import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

type PreparationViewIntroProps = {
  setView: (n: number) => void;
};

export default function PreparationViewIntro({
  setView,
}: PreparationViewIntroProps) {
  const { t } = useTranslation();
  return (
    <Grid
      container
      minHeight="60vh"
      mt={2}
      mb={2}
      sx={{
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "column",
          lg: "row",
        },
      }}
    >
      <Grid item xs />
      <Grid item lg={4}>
        <Box>
          <Box>
            <Typography fontSize={30} variant="h5">
              {t("introductions.preparation.text1")}
            </Typography>
          </Box>

          <Box>
            <Typography mt={2}>
              {t("introductions.preparation.text2")}
            </Typography>
          </Box>
          <Box mt={2}>
            <Typography>{t("introductions.preparation.text5")}</Typography>
            <List>
              <ListItem disableGutters key={1}>
                <ListItemIcon>
                  <Typography fontWeight={"bold"}>1.</Typography>
                </ListItemIcon>
                {t("preparationPage.text3")}
              </ListItem>
              <ListItem disableGutters key={2}>
                <ListItemIcon>
                  <Typography fontWeight={"bold"}>2.</Typography>
                </ListItemIcon>
                {t("preparationPage.text4")}
              </ListItem>
              <Typography>
                {t("preparationPage.text5")}{" "}
                <Typography component={NavLink} to={`/resources`}>
                  {t("labels.here")}
                </Typography>{" "}
                {t("preparationPage.text6")}
              </Typography>
            </List>
          </Box>
          <Box mt={3} sx={{ float: "right" }}>
            <Button variant="contained" onClick={() => setView(1)}>
              {t("buttons.letsStart")}
            </Button>
          </Box>
        </Box>
      </Grid>
      <Grid item xs />
    </Grid>
  );
}
